/* eslint-disable no-new */
// import AOS from 'aos';
// import 'aos/dist/aos.css';
// import Swiper from 'swiper';
// import GLightbox from 'glightbox';

const project = {
	init() {
		this.hamburger();
		this.fixedHeader();
		this.decorationPosition();
		this.initializeSubmenuButton();
		this.submenu();
	},
	hamburger() {
		const switchMenu = document.getElementById( 'switchMenu' );

		if ( ! switchMenu ) {
			return null;
		}
		const headerMenu = document.querySelector( '.header' );
		const textOpen = switchMenu.querySelector( '.screen-reader-text.open' );
		const textClose = switchMenu.querySelector(
			'.screen-reader-text.close'
		);

		let switchOn = false;
		switchMenu.addEventListener( 'click', () => {
			if ( ! switchOn ) {
				switchMenu.classList.add( 'open' );
				headerMenu.classList.add( 'open' );
				textOpen.classList.remove( 'active' );
				textClose.classList.add( 'active' );
				document.body.classList.add( 'prevent-scroll' );
				switchOn = true;
			} else {
				switchMenu.classList.remove( 'open' );
				headerMenu.classList.remove( 'open' );
				textOpen.classList.add( 'active' );
				textClose.classList.remove( 'active' );
				document.body.classList.remove( 'prevent-scroll' );
				switchOn = false;
			}
		} );

		window.addEventListener( 'resize', () => {
			if ( switchOn ) {
				switchMenu.classList.remove( 'open' );
				headerMenu.classList.remove( 'open' );
				textOpen.classList.add( 'active' );
				textClose.classList.remove( 'active' );
				switchOn = false;
				document.body.classList.remove( 'prevent-scroll' );
			}
		} );

		return null;
	},
	// eslint-disable-next-line consistent-return
	fixedHeader() {
		const header = document.getElementsByClassName( 'header--main' );
		let scrollObject = {};

		if ( header.length === 0 ) {
			return false;
		}

		function getScrollPosition() {
			scrollObject = {
				x: window.pageXOffset,
				y: window.pageYOffset,
			};
			// If you want to check distance
			if ( scrollObject.y > 100 ) {
				header[ 0 ].classList.add( 'header--scroll' );
			} else {
				header[ 0 ].classList.remove( 'header--scroll' );
			}
		}

		getScrollPosition();
	},
	decorationPosition() {
		const arrowDecorations =
			document.querySelectorAll( '.arrow-decoration' );
		if ( ! arrowDecorations ) {
			return null;
		}

		arrowDecorations.forEach( ( arrowDecoration ) => {
			const arrowValue = arrowDecoration.getAttribute(
				'data-arrow-position'
			);
			isTopArrow = arrowDecoration.classList.contains( 'arrow-top' );
			if ( isTopArrow ) {
				arrowDecoration.style.top = arrowValue + '%';
			}

			isBottomArrow =
				arrowDecoration.classList.contains( 'arrow-bottom' );
			if ( isBottomArrow ) {
				arrowDecoration.style.bottom = arrowValue + '%';
			}
		} );
	},
	submenu() {
		const menuLiItems = document.querySelectorAll(
			'.header__menu--main .menu-item-has-children'
		);

		// Add a click event listener to each submenu trigger button.
		menuLiItems.forEach( ( item ) => {
			const submenuButton = item.querySelector( '.open-submenu-btn' );
			const submenu = item.querySelector( '.sub-menu' );

			if ( submenuButton && submenu ) {
				submenuButton.addEventListener( 'click', () => {
					if (
						submenuButton.classList.contains( 'open' ) &&
						submenu.classList.contains( 'active' )
					) {
						submenuButton.classList.remove( 'open' );
						submenu.classList.remove( 'active' );
					} else {
						submenuButton.classList.add( 'open' );
						submenu.classList.add( 'active' );
					}
				} );
			}
		} );
	},
	initializeSubmenuButton() {
		const menuItems = document.querySelectorAll(
			'.header__menu--main .menu-item-has-children'
		);

		// Create and append new submenu buttons
		menuItems.forEach( ( item ) => {
			const existingButton = item.querySelector( '.open-submenu-btn' );

			if ( ! existingButton ) {
				const submenuOpenButton = document.createElement( 'button' );
				submenuOpenButton.classList.add( 'open-submenu-btn' );
				item.appendChild( submenuOpenButton );
			}
		} );
	},
	aos() {
		AOS.init();
	},
};

document.addEventListener( 'DOMContentLoaded', () => {
	project.init();
} );

window.addEventListener( 'scroll', project.fixedHeader );
